<div class="container-fluid cabecalho p-d-none p-d-xl-flex">
  <div class="container">
    <div class="p-d-flex p-jc-between p-ai-center">
        <ul>
          <li>
            <a href="https://www.trf5.jus.br/" class="links" target="_blank" rel="noopener"
              pTooltip="Acessar o Portal do TRF5" tooltipPosition="bottom">TRF5</a>
          </li>
          <li>
            <a href="http://www.jfal.jus.br/" class="links" target="_blank" rel="noopener"
              pTooltip="Acessar o Portal da Seção Judiciária de Alagoas" tooltipPosition="bottom">JFAL</a>
          </li>
          <li>
            <a href="http://www.jfce.jus.br/" class="links" target="_blank" rel="noopener"
              pTooltip="Acessar o Portal da Seção Judiciária do Ceará" tooltipPosition="bottom">JFCE</a>
          </li>
          <li>
            <a href="http://www.jfpb.jus.br/" class="links" target="_blank" rel="noopener"
              pTooltip="Acessar o Portal da Seção Judiciária da Paraiba" tooltipPosition="bottom">JFPB</a>
          </li>
          <li>
            <a href="https://www.jfpe.jus.br/" class="links" target="_blank" rel="noopener"
              pTooltip="Acessar o Portal da Seção Judiciária de Pernambuco" tooltipPosition="bottom">JFPE</a>
          </li>
          <li>
            <a href="http://www.jfse.jus.br/" class="links" target="_blank" rel="noopener"
              pTooltip="Acessar o Portal da Seção Judiciária de Sergipe" tooltipPosition="bottom">JFSE</a>
          </li>
        </ul>

        <app-botoes-acessibilidade [classe]="'header'"></app-botoes-acessibilidade>
    </div>
  </div>
</div>
